export default {
  buttonText: "Button",
  isWithArrow: true,
  color: "black",
  onClick: undefined
};
